import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

class scroll {
  constructor(context) {
    const headerHeight = context.querySelector('.header').clientHeight;
    const body = context.querySelector('body');
    
    /**
     * Hide logo text on frontpage when scrolling
     */
    if (body) {
      if (body.classList.contains('path-frontpage')) {
        const logoText = context.querySelector('.header__logo #text');
        const logoLetters = context.querySelector('.header__logo #letters');
        gsap.to(logoText, {
          opacity: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: context.querySelector('main'),
            start: `top ${headerHeight}px`,
            end: "+=50",
            scrub: 0
          }
        });
        gsap.to(logoLetters, {
          opacity: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: context.querySelector('main'),
            start: `top ${headerHeight}px`,
            end: "+=50",
            scrub: 0
          }
        });
      }
    }

    if (context.querySelector('.header__logo .logo')) {
      gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: context.querySelector('main'),
          start: `top ${headerHeight}px`,
          end: "bottom top",
          scrub: 1
        }
      }).fromTo(context.querySelector('.header__logo .logo'), {
        y: "4%"
      }, {
        y: "-15%"
      });
    }

    if (context.querySelectorAll('.header__text-repeat')) {
      gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: context.querySelector('body'),
          start: `top top`,
          end: `+=${headerHeight}`,
          scrub: 1
        }
      }).fromTo(context.querySelectorAll('.header__text-repeat'), {
        y: "0"
      }, {
        y: `${headerHeight / 3}px`
      }).fromTo(context.querySelectorAll('.header__text-repeat span:nth-child(n+1)'), {
        alpha: 1
      }, {
        alpha: 0
      });
  
      gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: context.querySelector('body'),
          start: `top top`,
          end: `+=${headerHeight / 2}`,
          scrub: 1
        }
      }).fromTo(context.querySelectorAll('.header__text-repeat span:nth-child(n+2)'), {
        alpha: 1
      }, {
        alpha: 0
      });
    }

    document.querySelectorAll('.paragraph--type--section-title.is-animated').forEach(paragraph => {
      paragraph.querySelectorAll('.as-h2').forEach(title => {
        const offset = title.dataset.index;
        const maxY = 100 * offset;
        gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: title,
            start: `top center`,
            end: "bottom top",
            scrub: 1
          }
        }).fromTo(title, {
          y: "0%"
        }, {
          y: `${maxY}%`
        })
      });
    });

    document.querySelectorAll('[data-scroll-parallax]').forEach(item => {
      gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: item,
          start: `top bottom`,
          end: "bottom top",
          scrub: 1
        }
      }).fromTo(item, {
        y: "10%"
      }, {
        y: "-10%"
      })
      /* gsap.fromTo(item, {
        y: -200,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: `top bottom`,
          end: "bottom top",
          scrub: 1
        }
      }); */
    });
  }
};

export default scroll;